import { render, staticRenderFns } from "./CodeQuery.vue?vue&type=template&id=3bd4a6fc&scoped=true"
import script from "./CodeQuery.vue?vue&type=script&lang=js"
export * from "./CodeQuery.vue?vue&type=script&lang=js"
import style0 from "./CodeQuery.vue?vue&type=style&index=0&id=3bd4a6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4a6fc",
  null
  
)

export default component.exports